var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
var RenameTipsComponent = /** @class */ (function (_super) {
    __extends(RenameTipsComponent, _super);
    function RenameTipsComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.replaceAll = new EventEmitter();
        _this.rename = new EventEmitter();
        _this.skipDuplicates = new EventEmitter();
        _this.active = false;
        return _this;
    }
    RenameTipsComponent.prototype.show = function () {
        this.active = true;
        this.modal.show();
    };
    RenameTipsComponent.prototype.close = function () {
        this.modal.hide();
        this.active = false;
    };
    RenameTipsComponent.prototype.replaceAllFunction = function () {
        this.replaceAll.emit();
    };
    RenameTipsComponent.prototype.renameFunction = function () {
        this.rename.emit();
    };
    RenameTipsComponent.prototype.skipDuplicatesFunction = function () {
        this.skipDuplicates.emit();
    };
    __decorate([
        ViewChild('renameTips', { static: false })
    ], RenameTipsComponent.prototype, "modal", void 0);
    __decorate([
        Input()
    ], RenameTipsComponent.prototype, "renameTipsText", void 0);
    __decorate([
        Output()
    ], RenameTipsComponent.prototype, "replaceAll", void 0);
    __decorate([
        Output()
    ], RenameTipsComponent.prototype, "rename", void 0);
    __decorate([
        Output()
    ], RenameTipsComponent.prototype, "skipDuplicates", void 0);
    RenameTipsComponent = __decorate([
        Component({
            selector: 'rename-tips',
            styles: [".modal .fe-modal-container .fe-modal-header{ border-bottom: 1px solid #f4f4f4; .fe-modal-header-title{ line-height: 50px; } } .rename-tips-container{ margin-top: 20px; width: 100%; min-height: 110px; display: flex; align-items: center; justify-content: center; p{ width: 80%; word-wrap: break-word; margin-bottom: 0; text-align: center; } }"],
            template: "<div bsModal id=\"renameTips\" #renameTips=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"renameTips\" aria-hidden=\"true\" [config]=\"{backdrop: 'static'}\" allow-drag> <div class=\"modal-dialog\"> <div class=\"modal-content fe-modal-container\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> <span>{{lc(\"Note\")}}</span> </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"rename-tips-container\"> <p>{{renameTipsText}}</p> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"replaceAllFunction()\"> {{lc(\"ReplaceAll\")}} </button> <button class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"renameFunction()\"> {{lc(\"Rename\")}} </button> <button class=\"fe-btn fe-btn-default fe-btn-secondary\" (click)=\"skipDuplicatesFunction()\"> {{lc(\"SkipDuplicates\")}} </button> <button [disabled]=\"active\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </div> </div> </div>"
        })
    ], RenameTipsComponent);
    return RenameTipsComponent;
}(ConfigureComponentBase));
export { RenameTipsComponent };
